import { Component } from '@angular/core';
import { environment } from '@ca/environment/environment';

@Component({
    selector: 'ca-footer-landing',
    templateUrl: './footer-landing.component.html',
    styleUrls: ['./footer-landing.component.scss'],
})
export class FooterLandingComponent {
    get landingPageUrl(): string {
        return environment.landingPageUrl;
    }
}
